<div *ngFor="let item of data">
    <app-p-collapse [item]="item"></app-p-collapse>
</div>